import { FlowDurationUnits, FlowFormV2Mode, isFlowFormV2WaitMode } from 'flow-schema';

import { BlockDurationField } from '../../ConfigFields/Duration.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';
import { FormBlockFormFields } from '../Form/FormFields';

const modeOptions = [
  {
    value: FlowFormV2Mode.AddOnly,
    label: 'No wait',
    subHeader: 'Block completes as soon as the formset is added to the patient.',
  },
  {
    value: FlowFormV2Mode.AddAndWait,
    label: 'Wait for formset to reach any terminal status',
    subHeader:
      'Block waits for the formset to reach any terminal state (completed or expired). If the timeout value specified below is reached first, the block errors.',
  },
  {
    value: FlowFormV2Mode.AddAndWaitForCompletion,
    label: 'Wait for formset to be completed',
    subHeader:
      'Block waits for the formset to be completed. If the timeout value specified below is reached first, the block errors.',
  },
];

export function FormV2BlockFormFields() {
  const { value: mode } = useSelectedNodeField<FlowFormV2Mode>('config.mode');
  const resolvedMode = mode ?? FlowFormV2Mode.AddAndWaitForCompletion;
  const waitsForFormSet = isFlowFormV2WaitMode(resolvedMode);
  const timeoutLabel =
    resolvedMode === FlowFormV2Mode.AddAndWaitForCompletion
      ? 'Form Set Completion Timeout'
      : 'Form Set Terminal State Timeout';

  return (
    <>
      <FormBlockFormFields mode="v2" />
      <BlockSelectField
        fieldName="config.mode"
        label="Mode"
        options={modeOptions}
        defaultValue={FlowFormV2Mode.AddAndWaitForCompletion}
      />
      {waitsForFormSet && (
        <BlockDurationField
          fieldName="config.timeout"
          valueLabel={timeoutLabel}
          unitFieldNameSuffix="units"
          allowedUnits={Object.values(FlowDurationUnits)}
          required
        />
      )}
    </>
  );
}
